import { render, staticRenderFns } from "./text-columns.vue?vue&type=template&id=3aeaea91&scoped=true"
import script from "./text-columns.vue?vue&type=script&lang=js"
export * from "./text-columns.vue?vue&type=script&lang=js"
import style0 from "./text-columns.vue?vue&type=style&index=0&id=3aeaea91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeaea91",
  null
  
)

export default component.exports